import { classNames, formatCurrency } from "helpers";
import { VehicleFinanceRow } from "services/api/reports/finance/types";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";
import TableIcon from "ui/components/Table/TableSearch/components/TableIcon";
import { VehicleFilterOption } from "./types";

const initialsOf = (name: string): string => (name?.trim()?.charAt(0) || "?").toUpperCase();

export const VEHICLE_FILTER_OPTIONS: VehicleFilterOption[] = [
  { value: "all", label: "Sve" },
  { value: "sold", label: "Prodana" },
  { value: "inStock", label: "Na stanju" },
];

export const VEHICLE_FINANCE_COLUMNS = (
  onVehicleClick: (event: React.MouseEvent, vehicleId: string) => void
): Column[] => [
  {
    title: "Vozilo",
    field: "",
    type: ColumnTypes.custom,
    render: (row: VehicleFinanceRow) => {
      const handleClick = (event: React.MouseEvent) => onVehicleClick(event, row.vehicleId);

      return (
        <div className="flex items-center gap-3 cursor-pointer" onClick={handleClick}>
          <TableIcon imageUrl={row.image ?? undefined} initials={initialsOf(row.vehicleName)} />
          <div className="min-w-0">
            <div className="text-sm font-medium text-sky-600 hover:text-sky-900 truncate">
              {row.vehicleName}
            </div>
            {row.registrationPlate && (
              <div className="text-xs text-slate-500 truncate">{row.registrationPlate}</div>
            )}
          </div>
        </div>
      );
    },
  },
  {
    title: "Nabava",
    field: "",
    type: ColumnTypes.custom,
    render: (row: VehicleFinanceRow) => (
      <div className="text-sm text-slate-700">{formatCurrency.format(row.purchase)}</div>
    ),
  },
  {
    title: "Ulaganja",
    field: "",
    type: ColumnTypes.custom,
    render: (row: VehicleFinanceRow) => (
      <div className="text-sm text-rose-600">{formatCurrency.format(row.investment)}</div>
    ),
  },
  {
    title: "Prodaja",
    field: "",
    type: ColumnTypes.custom,
    render: (row: VehicleFinanceRow) =>
      row.isSold ? (
        <div className="text-sm text-emerald-700">{formatCurrency.format(row.sale)}</div>
      ) : (
        <div className="text-sm text-slate-400">—</div>
      ),
  },
  {
    title: "Zarada",
    field: "",
    type: ColumnTypes.custom,
    render: (row: VehicleFinanceRow) => (
      <div
        className={classNames(
          "text-sm font-bold",
          row.profit >= 0 ? "text-emerald-700" : "text-rose-600"
        )}
      >
        {formatCurrency.format(row.profit)}
      </div>
    ),
  },
  {
    title: "Marža",
    field: "",
    type: ColumnTypes.custom,
    render: (row: VehicleFinanceRow) => (
      <div className="text-sm text-slate-700">
        {row.marginPercent === null ? "—" : `${row.marginPercent.toFixed(1)} %`}
      </div>
    ),
  },
  {
    title: "Dana",
    field: "",
    type: ColumnTypes.custom,
    render: (row: VehicleFinanceRow) => (
      <div className="text-sm text-slate-500">
        {row.daysInStock}
        {!row.isSold && (
          <span className="ml-1 text-amber-500" title="Još na stanju">
            ⏳
          </span>
        )}
      </div>
    ),
  },
];
